// extracted by mini-css-extract-plugin
module.exports = {"contact":"Patrol_contact__3aFVL","button":"Patrol_button__27J3d","searchBox":"Patrol_searchBox__2Ys_G"};